/**
 * Grid MatchHeight JS
 */
{
  window.setGridHeight = (selector) => {
    this.heightArray = [];
    this.offsetArrayArray = [];
    this.sectionArray = [];
  
  
    document.querySelectorAll(selector).forEach((grid, i) => {
      var tmp = { 'index': i, 'offsetheight': grid.closest(`[data-equal]`).offsetTop };
      this.offsetArrayArray.push(tmp)
    });
  
    this.diffrentsHeights = []
    this.offsetArrayArray.forEach(function (e) {
      if (this.diffrentsHeights.includes(e.offsetheight) == false) {
        this.diffrentsHeights.push(e.offsetheight)
      }
    })
  
    this.diffrentsHeights.forEach(function (e) {
      var data = [];
      for (var i = 0; i < this.offsetArrayArray.length; i++) {
        if (this.offsetArrayArray[i].offsetheight == e) {
          data.push(this.offsetArrayArray[i]);
        }
      }
  
      var getAllHeightArray = [];
      data.forEach(function (ele) {
        document.querySelectorAll(selector)[ele.index].removeAttribute('style');
        getAllHeightArray.push(document.querySelectorAll(selector)[ele.index].offsetHeight);
      })
  
      var getMaxHeight = Math.max.apply(Math, getAllHeightArray);
      data.forEach(function (ele) {
        document.querySelectorAll(selector)[ele.index].style.minHeight = getMaxHeight + 'px';
      });
    })
  
  }
  
  window.setGridHeight('.product-info');
  window.setGridHeight('.main_custom_row_slider .custom-row-slider.slick-initialized .height--adapt');
  
  window.addEventListener("resize",function() {
    window.setGridHeight('.product-info .product-block__title');
    window.setGridHeight('.product-info .product-block-options');
  });
}

/**
 * Read More/Less Js
 */
{
  var deskreadmore = document.querySelector(".readmore");
  var deskreadless = document.querySelector(".readless");
  
  if (deskreadmore) {
    deskreadmore.addEventListener('click', function (event) {
      event.preventDefault();
      var descriptionFull = document.querySelector('.product-description-full');
      descriptionFull.style.display = 'block';
      var descriptionShort = document.querySelector('.product-description-short');
      descriptionShort.style.display = 'none';
    });
  }
  if (deskreadless) {
    deskreadless.addEventListener('click', function (event) {
      event.preventDefault();
      var descriptionFull = document.querySelector('.product-description-full');
      descriptionFull.style.display = 'none';
      var descriptionShort = document.querySelector('.product-description-short');
      descriptionShort.style.display = 'block';
    });
  }
  
  var mobreadmore = document.querySelector(".mobile-readmore");
  var mobreadless = document.querySelector(".mobile-readless");
  
  if (mobreadmore) {
    mobreadmore.addEventListener('click', function (event) {
      event.preventDefault();
      var descriptionFull = document.querySelector('.mobile-product-description-full');
      descriptionFull.style.display = 'block';
      var descriptionShort = document.querySelector('.mobile-product-description-short');
      descriptionShort.style.display = 'none';
    });
  }
  if (mobreadless) {
    mobreadless.addEventListener('click', function (event) {
      event.preventDefault();
      var descriptionFull = document.querySelector('.mobile-product-description-full');
      descriptionFull.style.display = 'none';
      var descriptionShort = document.querySelector('.mobile-product-description-short');
      descriptionShort.style.display = 'block';
    });
  }
}

window.productgridswatch = () => {
  return;
  let color_option_selectors = document.querySelectorAll('.color-option-selectors');
  color_option_selectors.forEach(function (color_option_selector) {
    color_option_selector.addEventListener("mouseenter", _productGridvariantColorlinkChange.bind(this), false);
    color_option_selector.addEventListener("click", _productGridSizeSwatch.bind(this), false);
  });

  function _productGridvariantColorlinkChange(event) {

    let gridcolorOptionSelectors = event.currentTarget.closest(".product-block-options__inner").querySelectorAll(".color-option-selectors");
    gridcolorOptionSelectors.forEach(function (gridcolorOptionSelector) {
      gridcolorOptionSelector.classList.remove("active");
    });
    if (!event.currentTarget.classList.contains("active")) {
      event.currentTarget.classList.add("active");
    }

    let variantOfColorJson = JSON.parse(event.currentTarget.getAttribute("data-variant"));
    console.log("variantOfColorJson", variantOfColorJson);

    let productJson = JSON.parse(event.currentTarget.getAttribute("data-product"));
    // console.log("productJson",productJson);
    if (screen.width > 767) {
      if (productJson && variantOfColorJson) {
        let productUrl = `/products/${productJson.handle}?variant=${variantOfColorJson.id}`;
        // console.log("productUrl",productUrl);
        event.currentTarget.closest(".color_option_input").setAttribute("href", productUrl);
        //  event.currentTarget.closest(".color_option_input").querySelector("input").click();                 
      }
    }
    _productGridSizeSwatch(event);
  }

  function _productGridSizeSwatch(event) {
    console.log("_productGridSizeSwatch", event);
    let colorSwatches = event.currentTarget.closest(".js-main-block").querySelectorAll(".option-selector--swatch")[0];
    // console.log("colorSwatches",colorSwatches);
    if (colorSwatches) {
      Array.from(colorSwatches.querySelectorAll(".js-option")).map((colorSwatche) => {
        if (event.currentTarget.querySelector("input")) {
          let colorSwatchValue = colorSwatche.getAttribute("value").toLowerCase();
          let hoverSwatchValue = event.currentTarget.querySelector("input").getAttribute("value").toLowerCase();
          // console.log("colorSwatchValue",colorSwatchValue,"hoverSwatchValue",hoverSwatchValue);
          console.log("size_closet", colorSwatche.closest(".option-selectors").querySelectorAll(".option-selector")[0].querySelector(".option-selector__btns").querySelector("input"))
          if (colorSwatchValue === hoverSwatchValue) {
            console.log("colorSwatchValue", colorSwatchValue, hoverSwatchValue);
            // colorSwatche.closest(".option-selectors").querySelectorAll(".option-selector")[1].querySelector(".option-selector__btns").querySelector("input").click();
            colorSwatche.click();
          }
        }
      });
    }
  }
}

window.productgridswatch();